import { useCallback } from 'react'

import { useAccount, useChainId } from 'wagmi'

import { useSelfGeneratedAddress, useUpdateTransactionAndWait } from 'state/user/hooks'

import { errors } from 'constants/errors'
import { TxTypes } from 'constants/transaction'

import { NotificationTypes } from 'notifications/service'
import { useCallNotification } from 'notifications/hooks'

import { useRefund } from './useRefund'

export function useSendRefund() {
  const chainId = useChainId()
  const { address } = useAccount()

  const onRefund = useRefund()

  const privateKeyAddress = useSelfGeneratedAddress()

  const updateTransactionAndWait = useUpdateTransactionAndWait()

  const callNotification = useCallNotification()

  return useCallback(async () => {
    try {
      if (!address) {
        throw new Error(errors.wallet.WALLET_REQUIRED)
      }

      if (!privateKeyAddress) {
        throw new Error(errors.validation.PK_IS_REQUIRED)
      }

      const refundResponse = await onRefund()

      if (refundResponse === null) {
        return
      }
      if (refundResponse.txHash) {
        callNotification({ type: NotificationTypes.SUCCESS, message: 'Return funds transaction successfully sent' })
      }

      await updateTransactionAndWait({
        chainId,
        to: address,
        type: TxTypes.REFUND,
        from: refundResponse.from,
        txHash: refundResponse.txHash,
        value: refundResponse.value.toString(),
      })
    } catch (err) {}
  }, [chainId, address, onRefund, privateKeyAddress, updateTransactionAndWait])
}
